import React, { Fragment } from "react";
import "../../customizedLibs/polylineDecorator/leaflet.polylineDecorator";
import { Polyline } from "react-leaflet";
import ExpandedPolyline from "./ExpandedPolyline";
import L from "leaflet";

function PolylineWrapper({
  hidden,
  expanded,
  positions,
  handleClick,
  color,
  map,
  routeId,
  expandedRoutes
}) {
  return !hidden ? (
    !expanded ? (
      <Fragment>
        {/* Invisible polyline */}
        <Polyline
          positions={positions}
          onClick={() => handleClick(routeId)}
          weight={15}
          opacity={0}
          smoothFactor={3}
        />

        {/* White stroke polyline */}
        <Polyline
          positions={positions}
          onClick={() => handleClick(routeId)}
          color="#fff"
          weight={5}
          opacity={1}
          smoothFactor={3}
        />

        {/* Main polyline */}
        <Polyline
          positions={positions}
          onClick={() => {
            handleClick(routeId);
          }}
          smoothFactor={3}
          color={color}
          weight={3}
          opacity={0.7}
        />
      </Fragment>
    ) : (
      <ExpandedPolyline
        positions={positions}
        onClick={() => handleClick(routeId)}
        L={L}
        pane={"markerPane"}
        smoothFactor={5}
        color={color}
        map={map}
        expandedRoutes={expandedRoutes}
      />
    )
  ) : null;
}

export default PolylineWrapper;
